import { BaseModel } from '@models/baseModel.model';

export class BDMatrixEliminationCriteria extends BaseModel {
  bdMatrixEliminationCriteriaId: number;
  bdMatrixId: number;
  bdMatrixEliminationCategoryId: number;
  isSelected: boolean;

  referenceId: number;
}
